export const ALERT_TYPES = {
  error: {
    icon: "mdi-alert-octagon-outline",
    iconColor: "red darken-2",
    buttonText: "Aceptar",
    buttonColor: "blue darken-2",
  },
  warning: {
    icon: "mdi-alert-outline",
    iconColor: "orange",
    buttonText: "Aceptar",
    buttonColor: "blue darken-2",
  },
  info: {
    icon: "mdi-information-outline",
    iconColor: "blue",
    buttonText: "Aceptar",
    buttonColor: "blue darken-2",
  },
  success: {
    icon: "mdi-check-circle-outline",
    iconColor: "green",
    buttonText: "Aceptar",
    buttonColor: "blue darken-2",
  },
};

/**
 * Builds a dialog alert config for punctual user messages.
 * Extend by type (error, warning, info, success) or override any field.
 *
 * @param {Object} options
 * @param {'error'|'warning'|'info'|'success'} [options.type='error']
 * @param {string} [options.title]
 * @param {string} options.message
 * @param {string} [options.icon]
 * @param {string} [options.iconColor]
 * @param {string} [options.buttonText]
 * @param {string} [options.buttonColor]
 */
export function createAlert({
  type = "error",
  title,
  message,
  icon,
  iconColor,
  buttonText,
  buttonColor,
} = {}) {
  const defaults = ALERT_TYPES[type] || ALERT_TYPES.info;

  if (!message) {
    throw new Error("createAlert: 'message' is required");
  }

  return {
    type: ALERT_TYPES[type] ? type : "error",
    title: title ?? message,
    content: message,
    icon: icon ?? defaults.icon,
    iconColor: iconColor ?? defaults.iconColor,
    buttonText: buttonText ?? defaults.buttonText,
    buttonColor: buttonColor ?? defaults.buttonColor,
  };
}

/**
 * Shortcut to create an error alert for punctual user messages.
 *
 * @param {string|Object} messageOrOptions - Message string, or options with message/title/overrides
 */
export function createErrorAlert(messageOrOptions) {
  if (typeof messageOrOptions === "string") {
    return createAlert({ type: "error", message: messageOrOptions });
  }

  return createAlert({
    ...messageOrOptions,
    type: "error",
  });
}
